import { useState, useEffect, useRef } from 'react'
import { NoRecords } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useLoginHistory } from './api/loginHistoryapi';
import { ArrowDown, ArrowUp, Search } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { WaitingLoader } from '../../hooks/buttonLoad';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';


function LoginHistory() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search);
    const { data: getLoginHistory, isLoading } = useLoginHistory({
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: sortOrder
    })

    const totalRecords = getLoginHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Login History' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);

            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderLoginHistoryTable = () => (
        getLoginHistory?.data?.loginHistory?.length > 0 ?
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive admintable'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell>IP Address</TableCell>
                                    <TableCell>Browser</TableCell>
                                    <TableCell>OS</TableCell>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getLoginHistory?.data?.loginHistory?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell>{row?.ip}</TableCell>
                                        <TableCell>{row?.browser}</TableCell>
                                        <TableCell>{row?.device}</TableCell>
                                        <TableCell>{row?.location == "undefined, undefined, undefined" ? "Unknown" : row?.location}</TableCell>
                                        <TableCell>
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
            :
            <NoRecords />
    )

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        const tableContent = renderLoginHistoryTable();

        content = (
            <section>
                <h4>Login History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-md-4">
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color="#aaa9a9" />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search IP"
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {tableContent}
                </div>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

export default LoginHistory